<template>
    <div>
        <tracker-new-data-header v-if="!editTarget" :columns="columns"></tracker-new-data-header>

        <div v-if="canTrackManually" class="row px-3 new-data-inputs">
            <div class="col-2 px-1 py-3">
                <v-date-picker
                    dusk="date"
                    placeholder="MM/DD/YYYY"
                    id="date"
                    class="picker-container"
                    popover-align="left"
                    v-model="date"
                ></v-date-picker>
            </div>
            <div class="col-1 d-flex justify-content-center align-items-center">
                {{ totalSuccess }}
            </div>

            <div class="col-2">
                <div class="p-2">
                    <span class="small">Add entry: </span>
                    <prompt
                        :mini="true"
                        :iconset="helpers._get(customization, 'default_options.iconset', 0)"
                        :session="true"
                        @select-prompt="setResult($event)"
                    ></prompt>
                </div>
                <template v-for="(detailed_result, index) in detailed_results">
                    <div class="d-flex p-2">
                        <span class="small mr-2">{{ index + 1 }}. </span>
                        <prompt
                            :mini="true"
                            :prompt="[
                                null,
                                helpers._get(customization, 'default_options.iconset', 0),
                                detailed_result,
                            ]"
                            :key="index"
                        ></prompt>
                        <i
                            class="fa fa-times mx-2 cursor-pointer"
                            v-tooltip="'Remove this entry'"
                            @click="removeResult(index)"
                        ></i>
                    </div>
                </template>
            </div>

            <div class="col-1 d-flex align-items-center justify-content-end">
                {{ successRate }}%
            </div>

            <div class="px-1 col-5 py-3">
                <input v-model="note" class="form-control form-control-sm" name="note" />
            </div>
            <tracker-new-data-actions
                :saving="saving"
                :edit-target="editTarget"
                @save-data="submitData()"
                @edit-done="$emit('edit-done')"
            ></tracker-new-data-actions>
        </div>
    </div>
</template>

<script>
import { trackerNewDataCommon } from "./trackerNewDataCommon";
import Prompt from "../../ui/PromptIcon";

export default {
    name: "TrackerNewDataPercent",
    mixins: [trackerNewDataCommon],
    components: { Prompt },
    data() {
        return {
            columns: {
                titles: [`Date`, `Success`, `Attempts`, `Percent`, `Note`, ``],
                col: [2, 1, 2, 1, 5, 1],
            },
            date: new Date(),
            results: [],
            detailed_results: [],
            note: "",
        };
    },

    mounted() {
        if (this.editTarget) {
            this.populateEdit();
        }
    },

    beforeDestroy() {
        this.resetComponent();
    },

    computed: {
        totalSuccess() {
            return this.results ? this.results.reduce((agg, cur) => agg + cur, 0) : 0;
        },

        successRate() {
            if (this.results && this.results.length) {
                return parseInt((100 * this.totalSuccess) / this.results.length);
            }
            return 0;
        },
    },

    methods: {
        populateEdit() {
            let editTarget = { ...this.editTarget };
            this.date = editTarget.session_at;
            this.note = editTarget.notes;
            this.results = editTarget.data.results;
            this.detailed_results = editTarget.data.detailed_results;
        },

        setResult(event) {
            if (!this.results) this.results = [];
            if (!this.detailed_results) this.detailed_results = [];

            if (
                !this.goal.parameters.attempts ||
                this.results.length < this.goal.parameters.attempts
            ) {
                this.results.push(event[0]);
                this.detailed_results.push(event[1]);
            }
        },

        removeResult(index) {
            this.results.splice(index, 1);
            this.detailed_results.splice(index, 1);
        },

        submitData() {
            const payload = {
                data: {
                    type: "percent",
                    success: this.totalSuccess,
                    results: [...this.results],
                    detailed_results: [...this.detailed_results],
                    iconset: _.get(this.customization, "default_options.iconset", 0),
                    attempts: this.goal.parameters.attempts,
                },
                notes: this.note,
                session_at: this.isoDate,
            };
            this.$emit("save-data", payload);
            this.resetComponent();
        },

        resetComponent() {
            this.date = new Date();
            this.results = [];
            this.detailed_results = [];
            this.note = "";
        },
    },
};
</script>

<style scoped></style>
